import { schema } from "normalizr";

const PositionSchema = new schema.Entity("positions");
const PositionArraySchema = new schema.Array(PositionSchema);

export { PositionSchema, PositionArraySchema };